module.exports = __webpack_public_path__ + "img/camera.7a1c2062.svg";